{
  "Clear search": "Počisti iskanje"
}